/* WCAG 2.1 AA keyboard + iframe + media fixes — deployed 2026-08-07, updated 2026-08-07 PM */
(function(){
  // Announcement slider keyboard accessibility
  var slider = document.querySelector('[id^="Slider-"][id*="announcement"]');
  if (slider && !slider.hasAttribute('tabindex')) slider.setAttribute('tabindex','0');

  // Force scroll-trigger elements visible immediately
  document.querySelectorAll('.scroll-trigger').forEach(function(el){
    el.style.opacity = '1';
    el.style.transform = 'none';
  });

  // WCAG 4.1.2: iframes must have a title
  function titleIframes(){
    document.querySelectorAll('iframe:not([title])').forEach(function(f){
      var name = 'Embedded content';
      var src = f.src || '';
      if (src.indexOf('gorgias') > -1) name = 'Gorgias chat';
      else if (src.indexOf('youtube') > -1 || src.indexOf('youtu.be') > -1) name = 'YouTube video';
      else if (src.indexOf('wistia') > -1) name = 'Video player';
      else if (f.className.indexOf('plg-impact') > -1) name = 'Product video player';
      else if (src.indexOf('shop.app') > -1) name = 'Shop Pay';
      f.setAttribute('title', name);
    });
  }

  // WCAG 1.1.1: video poster <img> elements need alt text
  function fixVideoPosters(){
    document.querySelectorAll('video img:not([alt]), video > img[alt=""]').forEach(function(img){
      var product = document.querySelector('h1');
      var label = product ? product.textContent.trim() : 'Product';
      img.setAttribute('alt', label + ' — video');
    });
  }

  // WCAG 4.1.2: Seal Subscriptions injects nested interactive role=radio wrappers.
  // Remove the widget role from the wrapper; the inner label/input keeps the control accessible.
  function fixSealNesting(){
    document.querySelectorAll('.sls-selling-plan-group-first-line[role="radio"]').forEach(function(el){
      el.removeAttribute('role');
      el.removeAttribute('aria-checked');
    });
  }

  function run(){ titleIframes(); fixVideoPosters(); fixSealNesting(); }
  run();
  [1000, 3000, 6000].forEach(function(ms){ setTimeout(run, ms); });
})();
